import React from "react";

const Copyright = () => {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <footer className="Copyright">
      © Copyright {year} Outcess Solutions. All rights reserved.
    </footer>
  );
};

export default Copyright;
